import { skipToken } from "@reduxjs/toolkit/query/react";
import { useParams } from "react-router";
import {
  useGetBaseOrganizationUsageQuery,
  useGetGroupUsageDetailsQuery,
} from "Services";
import { FileType } from "Types";
import { useCurrentOrganization } from ".";

type UsageSummary = {
  total: number;
  used: number;
  isLoading: boolean;
};

const useUsageQuota = (usageType: FileType): UsageSummary => {
  const { groupId } = useParams();
  const currentOrganization = useCurrentOrganization();
  const { data: organizationUsage, isLoading: organizationIsLoading } =
    useGetBaseOrganizationUsageQuery(
      currentOrganization
        ? {
            organizationId: currentOrganization.id,
          }
        : skipToken,
    );

  const { data: groupsUsage, isLoading: groupIsLoading } =
    useGetGroupUsageDetailsQuery(
      groupId
        ? {
            groupId: groupId,
          }
        : skipToken,
    );

  let total = 0;
  let used = 0;

  if (groupsUsage?.limit) {
    if (usageType === "FILESTREAM") {
      total = groupsUsage.filestream_available;
      used = groupsUsage.filestream_usage_bytes;
    } else {
      total = groupsUsage.projects_available;
      used = groupsUsage.projects_usage_bytes;
    }
  } else {
    total = organizationUsage?.total_portal_capacity_bytes || 0;
    used = organizationUsage
      ? organizationUsage.organization_used_this_month_bytes_portal
      : 0;
  }

  return {
    total,
    used,
    isLoading: organizationIsLoading || groupIsLoading,
  };
};

export default useUsageQuota;
